exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-toolbar {\r\n    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)\r\n}\r\n\r\n.nav-toolbar__inner {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-flow: row nowrap;\r\n            flex-flow: row nowrap;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.nav-toolbar__item {\r\n    color: rgba(255, 255, 255, 0.24);\r\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0)     ;\r\n}\r\n\r\n.nav-toolbar__item.active md-icon {\r\n    width: 36px;\r\n    height: 36px;\r\n    line-height: 36px;\r\n    font-size: 36px;\r\n}\r\n\r\n.active {\r\n    color: rgb(149, 117, 205);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/navigation-toolbar/navigation-toolbar.component.css
// module id = ../../../../../src/app/shared/navigation-toolbar/navigation-toolbar.component.css
// module chunks = 4